import React from 'react';
import WordleStep from './wordle/WordleStep';
import ConnectionsStep from './connections/ConnectionsStep';
import CrosswordStep from './crossword/CrosswordStep';
import TimeGateStep from './timegate/TimeGateStep';
import { StepConfig } from '../types';

export interface PuzzleProps {
  step: StepConfig;
  storageKey: string;
  initiallySolved: boolean;
  disabled: boolean;
  onSolved: () => void;
}

export const Puzzle: React.FC<PuzzleProps> = ({ step, storageKey, initiallySolved, disabled, onSolved }) => {
  if (step.type === 'wordle') {
    return (
      <WordleStep
        key={storageKey}
        answer={step.answer}
        storageKey={`${storageKey}:wordle`}
        initiallySolved={initiallySolved}
        disabled={disabled}
        solvedMessage={step.message}
        onSolved={onSolved}
      />
    );
  }

  if (step.type === 'connections') {
    return (
      <ConnectionsStep
        key={storageKey}
        groups={step.groups}
        storageKey={`${storageKey}:connections`}
        initiallySolved={initiallySolved}
        disabled={disabled}
        onSolved={onSolved}
      />
    );
  }

  if (step.type === 'timegate') {
    return (
      <TimeGateStep
        key={storageKey}
        message={step.message}
        unlockAfterHours={step.unlockAfterHours}
        storageKey={`${storageKey}:timegate`}
        initiallySolved={initiallySolved}
        onSolved={onSolved}
        completionMessage={step.completionMessage}
      />
    );
  }

  return (
    <CrosswordStep
      key={storageKey}
      clues={step.clues}
      metaPhrase={step.metaPhrase}
      metaMap={step.metaMap}
      storageKey={`${storageKey}:crossword`}
      initiallySolved={initiallySolved}
      disabled={disabled}
      onSolved={onSolved}
    />
  );
};

export default Puzzle;


